var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_327_19447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5008 27.2008C22.6864 27.2008 27.7008 22.1864 27.7008 16.0008C27.7008 9.81519 22.6864 4.80078 16.5008 4.80078C10.3152 4.80078 5.30078 9.81519 5.30078 16.0008C5.30078 22.1864 10.3152 27.2008 16.5008 27.2008ZM17.9008 11.8008C17.9008 11.0276 17.274 10.4008 16.5008 10.4008C15.7276 10.4008 15.1008 11.0276 15.1008 11.8008V14.6008H12.3008C11.5276 14.6008 10.9008 15.2276 10.9008 16.0008C10.9008 16.774 11.5276 17.4008 12.3008 17.4008H15.1008V20.2008C15.1008 20.974 15.7276 21.6008 16.5008 21.6008C17.274 21.6008 17.9008 20.974 17.9008 20.2008V17.4008H20.7008C21.474 17.4008 22.1008 16.774 22.1008 16.0008C22.1008 15.2276 21.474 14.6008 20.7008 14.6008H17.9008V11.8008Z",
    fill: "#637FF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_327_19447",
    x: 5.30078,
    y: 4.80078,
    width: 22.3984,
    height: 24.3984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_327_19447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.dba2e8e82cd85dfdf2f63e0dba75fc96.svg";
export { ForwardRef as ReactComponent };